/**
 * In various contexts, such as with selections or current entity, we store
 * information about entities relative to something else. For example, we might
 * have an entity collection, `TvChannelEc`, and three TVs: `Living Room`,
 * `Bedroom`, and `Basement`. We could have a different TV channel selected on
 * each TV. To identify these separate selections in the `TvChannelEc`, we would
 * use a {@link Target}. So our selections in `TvChannelEc` could be:
 *
 * | Target | Selection |
 * |:--|:--|
 * | `Living Room` | Channel 1 |
 * | `Bedroom` | Channel 7 |
 * | `Basement` | Channel 99 |
 *
 * @see {@link Target.DEFAULT}
 */
export type Target = string | typeof Target.DEFAULT
export namespace Target {
  /**
   * In many cases where a {@link Target} is used, it is not always necessary to
   * use a {@link Target}. For example, with selections, it is common to just
   * have one set of selections in an entity collection. In those cases, instead
   * of making up an arbitrary {@link Target}, you can just use this
   */
  // NOTE: uses a single character for performance since this is used in a lot of
  // places, but an unusual character to avoid collisions
  export const DEFAULT = 'ø'
}
